export default __webpack_public_path__ + "390986abf0004f8fc790e3302d7ff1a6.png";